export default {
  methods: {
    displayServerErrors(errors) {
      const fields = Object.keys(errors);

      fields.forEach((field) => {
        const formattedField = field.replace(/_/g, '-');

        this.errors.add({
          field: formattedField,
          msg: errors[field].join('. '),
          id: `${formattedField}.backend`,
        });
      });
    },

    removeServerError(field) {
      this.errors.removeById(`${field}.backend`);
    },
  },
};
